export enum AdminRole {
  REFEREE_ADMIN = 0,
  REGISTRATION_MANAGER = 1,
  SUPERADMIN = 2,
  BRACKET_MANAGER = 3,
  HEAD_COACH = 4,
  COURT_MANAGER = 5,
  PADEL_REPORTS_VIEWER = 6,
  TOURNAMENT_MANAGER = 7,
  PHOTOGRAPHER = 8,
  SHOP_MANAGER = 9,
}

export const AdminRoleLabels: Record<AdminRole, string> = {
  [AdminRole.REFEREE_ADMIN]: "Referee Admin",
  [AdminRole.REGISTRATION_MANAGER]: "Registration Manager",
  [AdminRole.SUPERADMIN]: "Superadmin",
  [AdminRole.BRACKET_MANAGER]: "Bracket Manager",
  [AdminRole.HEAD_COACH]: "Head Coach",
  [AdminRole.COURT_MANAGER]: "Court Manager",
  [AdminRole.PADEL_REPORTS_VIEWER]: "Padel Reports Viewer",
  [AdminRole.TOURNAMENT_MANAGER]: "Tournament Manager",
  [AdminRole.PHOTOGRAPHER]: "Photographer",
  [AdminRole.SHOP_MANAGER]: "Shop Manager",
};
